module.exports = __webpack_public_path__ + "static/media/clock.b2b383e9.svg";